export const dogState = {
	name: '',
	key: '',
	breed: [],
	dob: '',
	birthYear: undefined,
	ageContext: '',
	alterationStatus: '',
	gender: '',
	temperment: '',
	bodyCondition: '',
	activityLevel: '',
	eatingBehavior: '',
	currentMealType: '',
	currentMealTypeBrand: '',
	currentMealSize: '',
	treats: '',
	scraps: '',
	foodAllergies: []
}

const address = {
	streetAddress: '',
	streetAddress2: '',
	city: '',
	state: '',
	postalCode: ''
}

export default {
	activeSection: 0,
	activeSegment: 0,
	completedSections: [],
	completedSegments: [],
	initialStepData: {},
	actionsOpen: true,
	actionsText: '',
	phone: '',
	subscribeSMS: true,
	rawData: {},
	firstName: '',
	lastName: '',
	email: '',
	password: '',
	numberOfDogs: undefined,
	dogs: [],
	selectedDog: 0,
	shippingAddress: { ...address },
	billingAsShipping: false,
	billingAddress: { ...address },
	planQuote: null,
	discountCode: '',
	acceptedPlans: {},
	canStepForward: false,
	canSkipStep: false,
	navigationOpen: true
}
